<template>
  <div class="pa-4 pb-2 text-caption text-textLight text-uppercase">
    New profile preview
  </div>
  <div class="wizard-profile-preview d-flex flex-column ga-4 pa-4">
    <div
      v-if="loading"
      class="d-flex justify-center align-center h-100"
    >
      <v-progress-circular
        indeterminate
        color="brandPrimary"
        size="48"
        width="3"
      />
    </div>

    <template v-else-if="profile">
      <div class="d-flex flex-column ga-1">
        <div class="text-body-1 text-textDarkest text-center">
          {{ profile.title }}
        </div>

        <div class="d-flex justify-center">
          <JobProfileStatus
            :is-hris-profile="profile.is_hris_profile"
            :is-archived="profile.is_archived"
            :is-template="profile.is_template"
          />
        </div>

        <JobProfileMeta
          :profile="profile"
          class="justify-center"
        />
      </div>

      <v-divider class="opacity-100" />

      <div
        v-for="field in nonEmptyFields"
        :key="field.id"
      >
        <div class="d-flex justify-end mb-2">
          <FieldLabel>
            {{ field.label }}
          </FieldLabel>
        </div>

        <DocumentPreviewFieldHtml :html="field.headerHtml" />
        <DocumentPreviewFieldHtml :html="field.html" />
        <DocumentPreviewFieldHtml :html="field.footerHtml" />
      </div>
    </template>

    <div
      v-else
      class="d-flex align-center justify-center h-100 text-body-2 text-textLight text-center pa-6"
    >
      <slot name="empty">
        Select a result to preview its content here.
      </slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DocumentPreviewFieldHtml from '@ui/components/general/DocumentPreviewFieldHtml/DocumentPreviewFieldHtml.vue';
import FieldLabel from '@/components/editor/field/FieldLabel.vue';
import JobProfileStatus from '../editor/JobProfileStatus.vue';
import JobProfileMeta from '../editor/JobProfileMeta.vue';

const props = defineProps({
  profile: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const nonEmptyFields = computed(() => {
  const jobFields = props.profile?.fields || [];
  return jobFields
    .map((field) => {
      const blocks = typeof field.blocks === 'string'
        ? [{ type: 'paragraph', html: field.blocks }]
        : (field.blocks || []);

      const headerBlocks = Array.isArray(field.header) ? field.header : [];
      const footerBlocks = Array.isArray(field.footer) ? field.footer : [];

      return {
        ...field,
        id: field.id || field.type,
        html: blocks.map((b) => b.html).join(''),
        headerHtml: headerBlocks.map((b) => b.html).join(''),
        footerHtml: footerBlocks.map((b) => b.html).join(''),
      };
    })
    .filter((field) => field.blocks?.some((block) => block.html?.trim?.()));
});
</script>
